module.exports = __webpack_public_path__ + "static/img/why-5.86352e03.jpg";